import Icon, { ICON_NAMES } from "shared/components/utils/Icon";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import VStack from "shared/components/layout/stack/VStack";
import { SegmentedButton, SegmentedWrapper, StyledText } from "./SegmentedControl.styles";

const SegmentedControl = ({
    value,
    options = [],
    onChange = () => void 0,
    disabled = false,
    isDisabled = false,
    filterLabel,
    segmentedButtonType = "submit",
    ...rest
}) => {
    return (
        <VStack spacing="Zero_25">
            {filterLabel && (
                <StyledText variant="Headline_5" disabled={isDisabled}>
                    {filterLabel}
                </StyledText>
            )}
            <SegmentedWrapper role="group" {...rest}>
                {options.map(({ value: optionValue, label, icon }) => (
                    <SegmentedButton
                        type={segmentedButtonType}
                        key={optionValue}
                        aria-pressed={value === optionValue}
                        onClick={() => onChange(optionValue)}
                        disabled={value !== optionValue && disabled}
                    >
                        <HStack spacing="Zero_25" align="center">
                            {icon && <Icon name={icon} />}
                            {label}
                        </HStack>
                    </SegmentedButton>
                ))}
            </SegmentedWrapper>
        </VStack>
    );
};

SegmentedControl.defaultProps = {
    filterLabel: "Show",
};

SegmentedControl.propTypes = {
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.oneOf(ICON_NAMES),
        })
    ),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    isDisabled: PropTypes.bool,
    filterLabel: PropTypes.string,
    segmentedButtonType: PropTypes.string,
};

export default SegmentedControl;
